export enum ActionConstants {
    // ArticleActions
    ARTICLE_LIST_CHANGED,
    ARTICLE_LIST_UPDATE,

    // CatalogActions
    FILTER_CATALOG,
    SEARCH_CATALOG,
    CATALOG_UPDATE,

    // SavedataActions
    SAVE_DATA,
    KOMPAN_SAVE_DATA,

    // DebugActions
    UPDATE_DEBUG_SETTINGS,
    ENABLE_DEBUG_TAB,

    // ExportSettingActions
    TOGGLE_VALUE,

    // FloorPlanActions
    SETUP_FLOORPLAN,
    SET_FLOORPLAN_IMAGE,
    SET_IMAGE_ID,
    SET_FLOORPLAN_ANGLE,
    SET_FLOORPLAN_ORIENTATION,
    SET_FLOORPLAN_RATIO,

    // InputActions
    TOGGLE_CHECKBOX,

    // InspirationsActions
    SET_IMAGES,
    SET_INSPIRATIONS_SELECTMODE,
    SHOW_IMAGE,
    TOGGLE_IMAGE_SELECT,
    SHOW_SHARE_IMAGE_MENU,
    SET_ACTIVE_IMAGE,
    RESET_IMAGES,

    // NewsActions
    SET_NEWS,

    // PconLoginAction
    HIDE_PACKAGE_GROUPS,
    PCON_LOGIN_LOGOUT,
    SET_PCON_LOGIN_TOKEN,
    SET_PCON_LOGIN_USER,
    SET_PCON_LOGIN_ORGANIZATION,
    UPDATE_PACKAGE_GROUPS,
    UPDATE_PCON_LOGIN_CACHE,

    // PersistentActions
    ACCEPT_COOKIE,
    HIDE_BANNER,
    SET_AUTOSAVE_ID,
    SET_CURRENCY,
    SET_DATA_LANGUAGE,
    SET_IMAGE_FORMAT,
    SET_IMAGE_TRANSPARENT,
    SET_LANGUAGE,
    SET_MEASUREMENT,
    SET_PRICE_VISIBLITY,
    SET_SIDEBAR_POSITION,

    // ProjectSettingsActions
    SET_FLOOR_PLAN,
    SET_FLOORPLAN_BRIGHTNESS,
    SET_FLOORPLAN_OPACITY,
    SET_FLOORPLAN_COLOR_REDUCTION,
    SET_FLOORPLAN_SIZE,
    SET_GROUND_COLOR,
    SET_GROUND_TYPE,
    IMPORT_PROJECT_SETTINGS,

    // ProjectManagerActions
    PROJECT_EDITMODE,
    PROJECT_LIST_UPDATE,
    RESET_PROJECT_RELATED_SETTINGS,
    SET_ACTIVE_PROJECT,
    SET_LOADED_PROJECT,
    SET_PROJECT_FILTER,
    SET_PROJECTS_SORT,
    SET_PROJECT_SELECTION,
    TOGGLE_PROJECT_SELECTION,
    SET_PRICE_VISIBLITY_TEMP,
    SET_MEASUREMENT_TEMP,
    SET_CURRENCY_TEMP,
    SET_DATA_LANGUAGE_TEMP,

    // PropertyEditorActions
    PE_INVALIDE,
    PE_SETACTIVE,
    PE_SETUP,
    PE_START_SYNC,
    PE_STOP_SYNC,
    PE_ARTICLE_ITEM,

    // SceneActions
    MAXIMIZE_SCENE,
    SAVE_SELECTION,
    SET_ACTIVE_VIEW,
    SET_VIEWER_DIMENSIONS,
    UPDATE_SELECTION,
    UPDATE_UNDO_REDO,
    SET_3D_WALLMODE,

    // SelectBoxActions
    SET_ACTIVE_SELECTBOX,
    SHOW_SELECTBOX,

    // SessionActions
    UPDATE_EXCHANGE_RATES,

    // ToolsActions
    SEND_IMAGE,
    SET_CAMERA,
    SET_MULTISELECT,
    SET_RECTANGLESELECT,
    SHOW_CAMERA_SELECTION,
    SHOW_SMART_EXTRA,
    SET_WALLTOOL_FLAG,

    // TooltipActions
    HIDE_TOOLTIP,
    SHOW_TOOLTIP,

    // UrlActions
    HASH_CHANGED,

    // VisibilityActions
    SET_DIALOG,
    SET_LENGTHDIALOG,
    SET_OVERLAY,
    SET_POPUPMENU,
    SET_DONE_MESSAGE,
    SET_INFO_MESSAGE,
    SET_FULLSCREEN,

    // ViewSettingsActions
    ARTICLE_ADDED,
    CHANGE_SHARETAB,
    CHANGE_SIDEBAR, // also RoomActions
    LOCK_ALL,
    LOCK_SIDEBAR,
    CHANGE_HAMBURGER,
    SET_DRAG_MODE,
    SET_MESSAGE,
    SET_NETWORK_ERROR,
    SET_UNSAVED_CHANGES,
    SHOW_EXTRABUTTONS,
    TOGGLE_BARS,
    TOGGLE_CHOICEMENU,
    TOGGLE_SUBCHOICE,
    TRIGGER_DOWNLOAD,
    WINDOW_RESIZE,
    UPDATE_TOOLTIPS,

    // OAP
    OAP_UPDATE,
    OAP_DESTROY,
    OAP_SET_PROPERTY,
    OAP_SET_CLASS,
    OAP_POSITION,

    // AR
    AR_UPDATE,
    AR_DEVICE_DETECTED
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/ActionConstants.ts